import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { C } from '../tokens';

/* Bolt icon in square — matches the reference exactly */
function BoltLogo() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'center', marginBottom: 32 }}>
      <div style={{ width: 36, height: 36, background: C.primary, borderRadius: 10, display: 'grid', placeItems: 'center' }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff">
          <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
        </svg>
      </div>
      <h1 style={{ fontSize: 24, fontWeight: 700, letterSpacing: '-.02em' }}>
        Nieramind<span style={{ color: C.primary }}>.AI</span>
      </h1>
    </div>
  );
}

const focusIn = (e) => { e.target.style.borderColor = C.primary; e.target.style.boxShadow = `0 0 0 3px ${C.primary}20`; };
const focusOut = (e) => { e.target.style.borderColor = '#e5e7eb'; e.target.style.boxShadow = 'none'; };

export default function ForgotPasswordPage() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 16, background: '#f9fafb', fontFamily: "'Public Sans','Inter',sans-serif" }}>
      {/* Card */}
      <section style={{ width: '100%', maxWidth: 450, background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', boxShadow: '0 1px 3px rgba(0,0,0,.04)', padding: 32 }}>
        <BoltLogo />

        <div style={{ marginBottom: 24 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: '#111827', marginBottom: 8 }}>Forgot your password?</h2>
          <p style={{ fontSize: 14, color: '#6b7280', lineHeight: 1.6 }}>
            Enter your email address and we'll send you a link to reset your password.
          </p>
        </div>

        <form
          onSubmit={(e) => { e.preventDefault(); navigate('/email-success'); }}
          style={{ display: 'flex', flexDirection: 'column', gap: 24 }}
        >
          <div>
            <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: '#374151', textTransform: 'uppercase', letterSpacing: '.1em', marginBottom: 6 }}>
              Email Address
            </label>
            <input
              type="email"
              placeholder="name@company.com"
              required
              style={{
                width: '100%', padding: '16px', borderRadius: 8,
                border: '1px solid #e5e7eb', background: '#f9fafb',
                fontSize: 14, outline: 'none', color: '#111827',
                transition: 'border-color .2s, box-shadow .2s',
              }}
              onFocus={focusIn}
              onBlur={focusOut}
            />
          </div>

          <button
            type="submit"
            style={{
              width: '100%', padding: '16px 24px', borderRadius: 8,
              border: 'none', background: C.primary, color: '#fff',
              fontSize: 15, fontWeight: 700, cursor: 'pointer',
              boxShadow: '0 4px 16px rgba(0,0,0,.08)',
              transition: 'transform .1s',
            }}
            onMouseDown={e => e.currentTarget.style.transform = 'scale(.98)'}
            onMouseUp={e => e.currentTarget.style.transform = 'scale(1)'}
          >
            Send Reset Link
          </button>
        </form>

        <div style={{ paddingTop: 20, textAlign: 'center' }}>
          <Link to="/login" style={{ fontSize: 14, fontWeight: 700, color: C.primary, textDecoration: 'none' }}>
            Back to Login
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ marginTop: 32 }}>
        <p style={{ fontSize: 12, color: '#9ca3af' }}>© 2024 Nieramind.AI. All rights reserved.</p>
      </footer>
    </div>
  );
}
